/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

import { Module, Node } from '@msdyn365-commerce-modules/utilities';

import {
    IPasswordResetItem, IPasswordResetLoading, IPasswordResetLocalAccount, IPasswordResetViewProps
} from './password-reset';

const PasswordResetItem: React.FC<IPasswordResetItem> = ({
    wrapper,
    label,
    errorMessage,
    input
}) => {

    return (
        <Node {...wrapper}>
            {label}
            {errorMessage}
            {input}
        </Node>
    );
};

const LocalAccount: React.FC<IPasswordResetLocalAccount> = ({
    localAccount,
    items,
    errorMessage,
    buttonsWrapper,
    buttons,
    verificationSuccessModal,
    verificationSuccessModalMessage
}) => {

    return (
        <Node {...localAccount}>
            {items && items.map((item: IPasswordResetItem) => {
                return (
                    // tslint:disable-next-line:jsx-key
                    <PasswordResetItem {...item} />
                );
            })}
            {errorMessage && errorMessage.map((error: React.ReactNode, index: number) => {
                return (
                    <React.Fragment key={index}>
                        {error}
                    </React.Fragment>
                );
            })}
            <Node {...buttonsWrapper}>
                {buttons && buttons.map((button: React.ReactNode, index: number) => {
                    return (
                        <React.Fragment key={index}>
                            {button}
                        </React.Fragment>
                    );
                })}
            </Node>

            <Node {...verificationSuccessModal}>
                <Node {...verificationSuccessModalMessage} />
            </Node>
        </Node>
    );
};

const PasswordResetLoading: React.FC<IPasswordResetLoading> = ({
    modal,
    modalBody,
    icon,
    message,
}) => {
    return (
        <Node {...modal}>
            <Node {...modalBody}>
                {icon}
                {message}
            </Node>
        </Node>
    );
};

const PasswordResetView: React.FC<IPasswordResetViewProps> = props => {

    const {
        passwordReset,
        viewState,
        loading,
        defaultAADConainer,
        aadConainer,
        heading,
        passwordResetLocalAccount
    } = props;

    return (
        <Module {...passwordReset}>
            {viewState.isShowLoading && <Node {...defaultAADConainer} />}
            {viewState.isShowLoading && <PasswordResetLoading {...loading} />}
            <Node {...aadConainer}>
                {heading}
                {LocalAccount(passwordResetLocalAccount)}
            </Node>
        </Module>
    );
};

export default PasswordResetView;
